import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { separateThousands } from '@alfa-bank/site-helpers-transform/numbers/separate-thousands';
import { PureInput } from '@alfa-bank/site-pure-input';

import type { TMaskInput, IDeps } from './models';
import { MaskInput as Component } from './mask-input';
import styles from './styles/styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const MaskInput = createWidget<IDeps, TMaskInput>({ PureInput, styles, separateThousands })(
    Component
);
